import axios from 'axios';
import keys from './keys';
import { useQuery } from '@tanstack/react-query';

const useGetPlan = ({ planId }) => {
  const query = useQuery({
    queryKey: keys.plan(planId),
    queryFn: async () => {
      const res = await axios.get(`/public/plan/${planId}`);
      return res.data;
    },
    enabled: !!planId,
  });

  return {
    plan: query.data,
    planError: query.error,
    isPlanFetchError: query.isError,
    isPlanFetchSuccess: query.isSuccess,
    isPlanFetching: query.isFetching,
    isPlanLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetPlan;
